<template>
  <AppContent :label="App.MenuMain.DOCUMENTS_DOE">
    <b-loading :active="isLoadingFull" />
    <b-tabs
      v-model="activeTab"
      class="block custom-padding tabs-mobile"
      :animated="false"
      expanded
      multiline
      role="tablist"
    >
      <b-tab-item :value="TABS.AUTHORIZE.value" role="tab">
        <template slot="header">
          <b-icon icon="book-alert" />
          <span class="tabs-title" data-cy="doe-authorize">
            {{ TABS.AUTHORIZE.name }}
          </span>
        </template>
        <DOEPending :exportDOE="exportLoteDOE" />
      </b-tab-item>

      <b-tab-item :value="TABS.PROGRAMMED.value" role="tab">
        <template slot="header">
          <b-icon icon="book-clock" />
          <span class="tabs-title" data-cy="doe-programmed">
            {{ TABS.PROGRAMMED.name }}
          </span>
        </template>
        <DOEProgrammed />
      </b-tab-item>

      <b-tab-item :value="TABS.REFUSED.value" role="tab">
        <template slot="header">
          <b-icon icon="book-cancel" />
          <span class="tabs-title" data-cy="doe-refused">
            {{ TABS.REFUSED.name }}
          </span>
        </template>
        <DOERefused />
      </b-tab-item>

      <b-tab-item :value="TABS.PUBLICATED.value" role="tab">
        <template slot="header">
          <b-icon icon="book-check" />
          <span class="tabs-title" data-cy="doe-publicated">
            {{ TABS.PUBLICATED.name }}
          </span>
        </template>
        <DOEPublished />
      </b-tab-item>
    </b-tabs>
  </AppContent>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from "vuex";
import { exportFiles } from "@/utils/fileUtility";

import AppContent from "@/layout/AppContent";

import DOEPending from "@/views/App/DOEPending";
import DOEProgrammed from "@/views/App/DOEProgrammed";
import DOERefused from "@/views/App/DOERefused";
import DOEPublished from "@/views/App/DOEPublished";
import ModalWarningDOE from "@/views/App/ModalWarningDOE.vue";

import { App, General } from "@/utils/constants";
import { DOE_PANEL_TABS as TABS } from "@/utils/enumerate";

export default {
  name: "DOEPanel",
  components: {
    AppContent,
    DOEPending,
    DOEProgrammed,
    DOERefused,
    DOEPublished
  },

  data() {
    return {
      App,
      General,
      TABS,
      isLoadingFull: false
    };
  },

  computed: {
    ...mapGetters({
      getCurrentTab: "getCurrentTabDOEPanel"
    }),
    activeTab: {
      get() {
        return this.getCurrentTab.value;
      },
      set(value) {
        this.setCurrentTab(this.TABS[value].value);
      }
    }
  },

  methods: {
    ...mapMutations({
      setCurrentTab: "setCurrentTabDOEPanel"
    }),
    ...mapActions({
      requestFile: "requestDataProcessFile"
    }),

    async exportLoteDOE(documents, editable = false) {
      this.isLoadingFull = true;
      const checkFiles = documents.filter(document =>
        document.signature_file?.find(signature =>
          ["PENDING", "REFUSED"].includes(signature.status)
        )
      );
      if (checkFiles.length && this.activeTab !== this.TABS.AUTHORIZE.value)
        this.$buefy.modal.open({
          parent: this,
          component: ModalWarningDOE,
          props: {
            listDocuments: checkFiles
          },
          canCancel: ["escape", "x", "outside"],
          hasModalCard: true,
          trapFocus: true
        });
      else {
        const docList = await this.requestFile({
          fileIds: documents.map(doc => ({
            process_file_id: doc.id
          })),
          processId: this.getProcessId,
          editable,
          isDoe: true
        });
        if (docList) {
          const links = docList.reduce((acc, actual) => {
            acc[actual.process_file_id] = actual.url_file;
            return acc;
          }, {});
          const newDocList = documents.map(doc => ({
            ...doc,
            file: links[doc.id],
            file_editable: links[doc.id]
          }));
          await exportFiles(newDocList, editable);
        }
      }
      this.isLoadingFull = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.tabs-title {
  font-size: 1rem;
  font-weight: bold;
}
</style>
